module.exports = __webpack_public_path__ + "img/8898582b38cc738e27b582c8f0b65a2e.png";